import DOMPurify from "dompurify";

/**
 * Sanitize HTML for v-html (vue.config.js wraps EVERY v-html with xss(_s(...))).
 * This is the app-wide v-html safety net, so its allow-list must cover every kind
 * of safe markup we legitimately render — not just search highlighting.
 *
 * Originally inline-only (mark/strong/…), which silently stripped the block-level
 * structure (p/h1-6/ul/ol/li/table/…) that Chat's renderMd produces from markdown,
 * collapsing rich answers into one wall of text. We allow the standard safe
 * formatting tags here. DOMPurify still removes script/iframe/object, on* event
 * handlers, and javascript:/data: URIs regardless of this list, so widening to
 * these presentational tags does not weaken XSS protection.
 */
export function sanitizeHtml(html) {
  if (html == null || html === "") return "";
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS: [
      // inline (incl. search-highlight markup)
      "span", "mark", "b", "strong", "i", "em", "u", "s", "del", "ins",
      "sub", "sup", "small", "code", "a", "br",
      // block structure
      "p", "div", "hr", "blockquote", "pre",
      "h1", "h2", "h3", "h4", "h5", "h6",
      "ul", "ol", "li",
      // tables
      "table", "thead", "tbody", "tfoot", "tr", "th", "td",
    ],
    ALLOWED_ATTR: ["class", "href", "target", "rel", "title", "id", "colspan", "rowspan", "start", "align"],
  });
}
